"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _SelectInner2 = require("./SelectInner");

var _SelectInner3 = _interopRequireDefault(_SelectInner2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectOnChangeFix = function (_SelectInner) {
    (0, _inherits3.default)(SelectOnChangeFix, _SelectInner);

    function SelectOnChangeFix() {
        (0, _classCallCheck3.default)(this, SelectOnChangeFix);
        return (0, _possibleConstructorReturn3.default)(this, (SelectOnChangeFix.__proto__ || (0, _getPrototypeOf2.default)(SelectOnChangeFix)).apply(this, arguments));
    }

    (0, _createClass3.default)(SelectOnChangeFix, [{
        key: "onSelect",
        value: function onSelect(value, context) {
            var _props = this.props,
                multiple = _props.multiple,
                hiddenSelected = _props.hiddenSelected,
                labelInValue = _props.labelInValue,
                data = void 0,
                changeValue = void 0;


            this.cacheDataByValue(value);
            data = this.getDataByValue(value).map(function (item) {
                var option = item;
                if (option) {
                    delete option.__key;
                }
                return option;
            });
            changeValue = data.map(function (item) {
                return item.value != null ? item.value : item;
            });
            if (!('value' in this.props)) {
                this.setState({ value: value, inputValue: this.getDisplayByValue(value) });
            }
            if (!multiple || hiddenSelected) {
                this.onVisibleChange(false);
            }
            if (!multiple) {
                changeValue = changeValue[0];
                data = data[0];
            }
            // 0 为允许可选值
            if (("value" in this.props && changeValue !== 0 ? changeValue != this.state.value : this.oldValue !== changeValue) || this.isCombobox) {
                if (labelInValue) {
                    this.props.onChange(data, data);
                } else {
                    this.props.onChange(changeValue, data);
                }
                this.oldValue = changeValue;
            }
            if (this.clearValue) {
                this.clearValue();
            }
            if (context) {
                this.lastFocusedKey = 'index' in context ? context.index : context.props.index;
            }
        }
    }]);
    return SelectOnChangeFix;
}(_SelectInner3.default);

SelectOnChangeFix.propTypes = (0, _assign2.default)({}, _SelectInner3.default.propTypes);
SelectOnChangeFix.defaultProps = (0, _assign2.default)({}, _SelectInner3.default.defaultProps);
exports.default = SelectOnChangeFix;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-field@0.0.22@@alicd/crui-select-field/lib/SelectOnChangeFix.js
// module id = 666
// module chunks = 0